export default __webpack_public_path__ + "static/media/topTitle.07366c22.png";